import React, { useEffect, useRef, useState } from "react";
import { DropdownStatusList, EmptyString } from "utils/Constant";
import { addSpaceEvery4, GetStatus, money } from "utils/helpers";
import DatePicker from "components/Input/DatePicker";
import Dropdown from "components/Input/Dropdown";
import { useModal } from "utils/context/ModalContext";
import { FilterCard, GridDeleteButton, GridEditButton, GridViewButton, MainBodyCard, PagesTitle } from "components/Cards";
import { TransactionService } from "services/TransactionService/TransactionService";
import { ReloadButton } from "components/Button/ReloadButton";
import { useVariable } from "utils/context/VariableContext";
export const API_BASE_URL = process.env.REACT_APP_API_URL

export default function TransferHistory(){
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchCustomerPaymentList, fetchProceedPayment, fetchCustomerPaymentSummary } = TransactionService()
    const { isAdmin, transferSourceOptions, locationOptions } = useVariable()

    const debounceRef = useRef(null)

    const [transactionDate, setTransactionDate] = useState(new Date())    
    const [customerPaymentListPaidTransfer, setCustomerPaymentListPaidTransfer] = useState([])
    const [customerPaidTransfer, setCustomerPaidTransfer] = useState([])

    const [paidTransferCustomerNameFilter, setPaidTransferCustomerNameFilter] = useState("")
    const [paidTransferBeneficiaryNameFilter, setPaidTransferBeneficiaryNameFilter] = useState("")
    const [paidTransferLocationFilterOptions, setPaidTransferLocationFilterOptions] = useState(locationOptions)
    const [paidTransferLocationIdFilter, setPaidTransferLocationIdFilter] = useState("")
    const [paidTransferStatusFilter, setPaidTransferStatusFilter] = useState("1") // 1 = Active

    useEffect(() => {
        const onLoad = async () => {
            showLoading()

            try {
                const res = await fetchCustomerPaymentList(transactionDate, '2', '', '1')
                if (!res) return

                setCustomerPaymentListPaidTransfer(res.data)
                setCustomerPaidTransfer(res.data)
            }
            finally {
                hideLoading()
            }
        }
        
        onLoad()
    },[transactionDate])

    // Event Change
    useEffect(() => {
        const filteredData = customerPaidTransfer.filter(item => {
            // --- Normalize search inputs ---
            const nameSearch = (paidTransferCustomerNameFilter || "").toLowerCase().trim();
            const beneficiarySearch = (paidTransferBeneficiaryNameFilter || "").toLowerCase().trim();
            const locationSearch = (paidTransferLocationIdFilter?.label || "").toLowerCase();
            const statusSearch = (paidTransferStatusFilter || "").toLowerCase();

            // --- Normalize item fields (avoid undefined/null errors) ---
            const customerName = (item.customerName || "").toLowerCase();
            const accountName = (item.accountName || "").toLowerCase();
            const locationName = (item.locationName || "").toLowerCase();
            const statusName = (item.status || "").toLowerCase(); // adjust key if different

            // --- Matching logic ---
            const matchesName = nameSearch
                ? customerName.includes(nameSearch)
                : true;

            const matchesBeneficiary = beneficiarySearch
                ? accountName.includes(beneficiarySearch)
                : true;

            const matchesLocation = locationSearch
                ? locationName === locationSearch
                : true;

            const matchesStatus = statusSearch
                ? statusName === statusSearch
                : true;

            // If no name/beneficiary search, don't filter by them
            const hasSearch = nameSearch || beneficiarySearch;

            return (
                matchesName &&
                matchesBeneficiary &&
                matchesLocation &&
                matchesStatus
            );
        });

        setCustomerPaymentListPaidTransfer(filteredData);
    }, [
        customerPaidTransfer,
        paidTransferCustomerNameFilter,
        paidTransferBeneficiaryNameFilter,
        paidTransferLocationIdFilter,
        paidTransferStatusFilter
    ])

    return(
        <MainBodyCard>
            <PagesTitle title='Riwayat Transfer' />
            
            {/* Filter */}
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 mt-3">
                <FilterCard title='Tanggal Transaksi'>
                    <DatePicker className="w-full h-10 bg-white" value={transactionDate} onChange={setTransactionDate} />
                </FilterCard>
                
                <FilterCard title='Nama Customer'>
                    <input 
                        className="input" 
                        value={paidTransferCustomerNameFilter} 
                        onChange={(e) => setPaidTransferCustomerNameFilter(e.target.value)} 
                        placeholder="Customer Name" 
                    />
                </FilterCard>
                <FilterCard title='Nama Rekening Tujuan'>
                    <input 
                        className="input" 
                        value={paidTransferBeneficiaryNameFilter} 
                        onChange={(e) => setPaidTransferBeneficiaryNameFilter(e.target.value)} 
                        placeholder="Beneficiary Name" 
                    />
                </FilterCard>
                <FilterCard title='Lokasi'>
                    <Dropdown className="w-full"
                        value={paidTransferLocationIdFilter} 
                        options={paidTransferLocationFilterOptions}
                        onChange={(e) => setPaidTransferLocationIdFilter(e)}
                        placeholder="All Location"
                    />
                </FilterCard>
                <FilterCard title='Status'>
                    <Dropdown className="w-full sm:w-48"
                        value={paidTransferStatusFilter} 
                        options={DropdownStatusList} 
                        onChange={(e) => { setPaidTransferStatusFilter(e.value) }} 
                        placeholder="All"
                    />
                </FilterCard>

                <FilterCard title={'.'} width={'w-auto'}>
                    <ReloadButton />
                </FilterCard>
            </div>

            {/* Paid Transfer */}
            <div className={`rounded shadow-md`}>

                {/* Desktop version */}
                <table className="w-full border bg-white mt-4 ">
                    <thead>
                        <tr className="h-14">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Customer Name</th>
                            <th className="font-semibold text-left px-2">Beneficiary Account</th>
                            <th className="font-semibold text-left px-2">Amount</th>
                            <th className="font-semibold text-left px-2">Remark</th>
                            <th className="font-semibold text-left px-2">Location</th>
                            <th className="font-semibold text-left px-2">Transfer Source</th>
                            {/* {isAdmin && <th className={`font-semibold sm:w-24`}>Action</th>} */}
                        </tr>
                    </thead>
                    <tbody className="border">
                        {customerPaymentListPaidTransfer?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-300" key={ i }>
                                    <td className="text-center">{ i + 1 }</td>
                                    <td className="px-2">
                                        <span>{data.customerName.toUpperCase()}</span>
                                    </td>
                                    <td className="px-2">
                                        <div className="flex flex-col text-nowrap">
                                            <span>{data.accountName.toUpperCase()}</span>
                                            <span>{data.bankCode} - {addSpaceEvery4(data.accountNumber)}</span>
                                        </div>
                                    </td>
                                    <td className="px-2 text-nowrap">
                                        <span>Rp { money(data.amount) }</span>
                                    </td>
                                    <td className="px-2 text-nowrap">
                                        <span>{data.remark.toUpperCase()}</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.locationName.toUpperCase() }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <div className="flex flex-col">
                                            <span>{GetStatus(data.status)}</span>
                                            <span>{transferSourceOptions.find(opt => opt.value === String(data.transferSourceId)).label}</span>
                                        </div>
                                    </td>
                                    {/* {isAdmin && 
                                        <td className="">
                                            <div className="flex justify-center">
                                            </div>
                                        </td>
                                    } */}
                                </tr>
                            )
                        })}
                    </tbody>
                    <tfoot>
                        <tr className="h-12">
                            <th colSpan={3} className="font-semibold text-right px-2">Total</th>
                            <th colSpan={3} className="font-semibold text-left px-2">Rp { money(customerPaymentListPaidTransfer.reduce((total, item) => total + item.amount, 0)) }</th>
                            <th colSpan={3}></th>
                        </tr>
                    </tfoot>
                </table>
                
                {/* Mobile Version */}
                <div className="flex flex-col gap-2 mt-4 sm:hidden">
                    {customerPaymentListPaidTransfer.length === 0 && 
                        <div className="my-2 h-10 border-y hover:bg-slate-300 flex items-center justify-center">
                            <span className="text-center">No Data Available</span>
                        </div>
                    }
                    {customerPaymentListPaidTransfer.length > 0 && 
                        <div className="my-2 h-10 border-y hover:bg-slate-300 flex items-center justify-center">
                            <span className="font-semibold">Total : Rp { money(customerPaymentListPaidTransfer.reduce((total, item) => total + item.amount, 0)) }</span>
                        </div>
                    }
                    {customerPaymentListPaidTransfer?.map((data, i) => {
                        return(
                            <div className="border rounded-md p-2 flex flex-col">
                                <div className="flex justify-between">
                                    <span className="text-sm font-semibold">{ data.customerName.toUpperCase() }</span>
                                    <span className="text-sm">Paid</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-sm">{ data.bankName }</span>
                                    <span className="text-sm">{ data.accountNumber }</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="font-semibold text-sm">Rp { money(data.amount) }</span>
                                    <span className="text-sm">{ (transferSourceOptions.find(opt => opt.value === String(data.transferSourceId)).label.length > 16 ? transferSourceOptions.find(opt => opt.value === String(data.transferSourceId)).label.slice(0, 16).toUpperCase() + "..." : transferSourceOptions.find(opt => opt.value === String(data.transferSourceId)).label.toUpperCase()) }</span>
                                </div>
                                <div className={`${data.remark !== EmptyString ? 'flex' : 'hidden'}`}>
                                    <span className="text-sm">REMARK : { data.remark }</span>
                                </div>
                            </div>
                        )
                    })}      
                </div>
            </div>
        </MainBodyCard>
    )
}